import './styles/SettingsList.css';
import SettingsList from './SettingsList';
export default SettingsList;
